var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div style=\"margin-top:40px; margin-bottom: 40px;\" class=\"app-card\"><form name=\"cardForm\"><div id=\"card-element\"></div><div class=\"payment-receipt\"><label for=\"payment_receipt\" id=\"payment_receipt_label\"> <input id=\"payment_receipt\" type=\"checkbox\" ng-model=\"cardmodel.payment_receipt\" class=\"payment-receipt\">I want to receive a receipt for this payment</label></div><div id=\"card-errors\" role=\"alert\"></div></form></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/appCard/appCard.jade
// module id = 483
// module chunks = 0